"use strict";

import React from 'react';
import AppStore from '../stores/AppStore';

const RAKUTEN_HELP_MAILTO = 'mailto:help@rakuten.tv';
const RAKUTEN_PRIVACY_MAILTO = 'mailto:rtv-privacy@mail.rakuten.com';
const RAKUTEN_PRIVACY_POLICY_URL = 'https://www.rakuten.tv/pages/privacy_policy';

/**
 * MigrationTermsAndConditionPage component
 */
export default class MigrationTermsAndConditionPage extends React.Component {
    /**
     * React: render
     */
    render() {
        const t = (key) => AppStore.translate(key);

        return (
            <main className="content-page">
                <div className="row">
                    <div className="content col-xs-12 col-md-8">
                        <h1>{t('view.migration_terms_page.title')}</h1>
                        <p>{t('view.migration_terms_page.p1')}</p>
                        <p>{t('view.migration_terms_page.p2')}</p>
                        <p>{t('view.migration_terms_page.p3')}</p>
                        <p>{t('view.migration_terms_page.p4')}</p>
                        <p>{t('view.migration_terms_page.p5')}</p>
                        <p>{t('view.migration_terms_page.p6')}</p>
                        <p>{t('view.migration_terms_page.p7')}</p>
                        <p>{t('view.migration_terms_page.p8')}</p>
                        <p>
                            {t('view.migration_terms_page.p9_before')}
                            <a href={RAKUTEN_HELP_MAILTO}>{t('view.migration_terms_page.help_email')}</a>.
                        </p>
                        <p>{t('view.migration_terms_page.p10')}</p>
                        <p>{t('view.migration_terms_page.p11')}</p>
                        <p>{t('view.migration_terms_page.p12')}</p>
                        <p>{t('view.migration_terms_page.p13')}</p>

                        <h2>{t('view.migration_terms_page.section_availability_heading')}</h2>
                        <p>
                            {t('view.migration_terms_page.availability_before')}
                            <a href={RAKUTEN_HELP_MAILTO}>{t('view.migration_terms_page.help_email')}</a>.
                        </p>

                        <h2>{t('view.migration_terms_page.section_data_heading')}</h2>
                        <p>{t('view.migration_terms_page.data_p1')}</p>
                        <p>{t('view.migration_terms_page.data_p2')}</p>
                        <ul>
                            <li>{t('view.migration_terms_page.data_share_li1')}</li>
                            <li>{t('view.migration_terms_page.data_share_li2')}</li>
                            <li>{t('view.migration_terms_page.data_share_li3')}</li>
                            <li>{t('view.migration_terms_page.data_share_li4')}</li>
                            <li>{t('view.migration_terms_page.data_share_li5')}</li>
                        </ul>
                        <p>{t('view.migration_terms_page.data_p3')}</p>
                        <ul>
                            <li>{t('view.migration_terms_page.data_use_li1')}</li>
                            <li>{t('view.migration_terms_page.data_use_li2')}</li>
                            <li>{t('view.migration_terms_page.data_use_li3')}</li>
                            <li>{t('view.migration_terms_page.data_use_li4')}</li>
                        </ul>
                        <p>
                            {t('view.migration_terms_page.data_p4_before')}
                            <a href={RAKUTEN_PRIVACY_MAILTO}>{t('view.migration_terms_page.privacy_email')}</a>
                            {t('view.migration_terms_page.data_p4_after')}
                        </p>
                        <p>
                            {t('view.migration_terms_page.data_p5_before')}
                            <a href={RAKUTEN_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
                                {t('view.migration_terms_page.privacy_policy_link')}
                            </a>.
                        </p>
                        <p>
                            {t('view.migration_terms_page.data_p6_before')}
                            <a href={RAKUTEN_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
                                {t('view.migration_terms_page.privacy_policy_link')}
                            </a>
                            {t('view.migration_terms_page.data_p6_mid')}
                            <a href={RAKUTEN_PRIVACY_MAILTO}>{t('view.migration_terms_page.privacy_email')}</a>.
                        </p>
                    </div>
                </div>
            </main>
        );
    }
}
